// extracted by mini-css-extract-plugin
module.exports = {"dropzone":"dropzone_dropzone__3MXb3","children":"dropzone_children__3edWF","pointerEvent":"dropzone_pointerEvent__1kga2","pulse":"dropzone_pulse__J7huD"};